/**
 * content/index.ts — registry of page-help definitions, keyed by the
 * PageHelpButton's pageKey. Add a new page's guide here (one import + one
 * entry); the button, dialog, and shape test pick it up automatically.
 */

import type { HelpContent, PageHelpKey } from '../helpTypes';
import { testCatalogHelp } from './testCatalogHelp';
import { testMappingHelp } from './testMappingHelp';

export const HELP_CONTENT: Record<PageHelpKey, HelpContent> = {
  'test-catalog': testCatalogHelp,
  'test-mapping': testMappingHelp,
};
